module.exports = __webpack_public_path__ + "img/page-header.32c3b489.png";